import React, { useEffect, useState } from "react";
import { Modal, Button, Spin } from "antd";
import mammoth from "mammoth";

interface DocxViewerProps {
  docxFile: string;
}

const DocxViewer: React.FC<DocxViewerProps> = ({ docxFile }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [docContent, setDocContent] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    fetchAndConvertDocx(docxFile);
  }, [docxFile]);

  const fetchAndConvertDocx = (fileUrl: string) => {
    fetch(fileUrl)
      .then((response) => response.arrayBuffer())
      .then((arrayBuffer) => {
        return mammoth
          .convertToHtml({ arrayBuffer })
          .then((result) => {
            const html = result.value;
            setDocContent(html);
            setLoading(false);
          })
          .catch((err) => {
            console.error("转换失败：", err);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error("文件获取失败：", error);
        setLoading(false);
      });
  };

  return (
    <div style={{ margin: "20px 40px" }}>
      {loading ? (
        <Spin size="large" style={{ margin: "0 20px" }} />
      ) : docContent ? (
        <div dangerouslySetInnerHTML={{ __html: docContent }} />
      ) : (
        <div>正在加载文档...</div>
      )}
    </div>
  );
};

export default DocxViewer;
